import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { ListingOption } from '../../../../models/inModels/MarketPlaceModel';
import { ListingOptionsService } from '../../../../services/listing-options.service';

@Component({
  selector: 'app-create-listing-option',
  templateUrl: './create-listing-option.component.html',
  styleUrls: ['./create-listing-option.component.css']
})
export class CreateListingOptionComponent implements OnInit {
  model: ListingOption;
  loading = false;
  error: Message[];
  messages: Message[];
  groupId: number;
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ListingOptionsService) {
    }
    
  ngOnInit() {
    this.groupId = this.route.snapshot.params.groupId;
    this.model = new ListingOption();
  }

  goBack(): void {
    this.router.navigate(['/marketplace/listing-options']);
  }

  save() {
    this.loading = true;
    this.service.create(this.model).then(
      res => {
        this.model = new ListingOption(res);
        this.loading = false;
        this.router.navigate(['/marketplace/listing-options/edit/' + this.model.id]);
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/listing-option/create/option/create-listing-option.component.ts